<div class="side-line" [class.disabled]="disabled" [ngClass]="color"></div>
<div class="content">
  <ng-content select="[content]"></ng-content>
</div>
